import Api from '@/service/api';
import * as registrationHelper from '@/helpers/registration';
import * as cardActivation from '@/helpers/card-activation';

import Input from '@/components/Form/Input/index.vue';
import DateInput from '@/components/Form/DateInput/index.vue';
import GenderSwitch from '@/components/Form/GenderSwitch/index.vue';
import MultiloginInput from '@/components/Form/MultiloginInput/index.vue';
import LocationSelector from '@/components/Form/LocationSelector/index.vue';
import PasswordRating from '@/components/Form/PasswordRating/PasswordRating.vue';
import Checkbox from '@/components/Form/Checkbox/index.vue';

import { WEAK_PASSWORD, STRONG_PASSWORD } from '@/constants/constants';


export default {
  name: 'FillingInformation',

  components: {
    Input,
    DateInput,
    GenderSwitch,
    MultiloginInput,
    LocationSelector,
    PasswordRating,
    Checkbox,
  },

  mounted() {
    if (this.$route.query.isCardActivation === 'true') {
      this.isCardActivation = true;
      this.getCardData();
    }
  },

  watch: {
    password() {
      this.isDescriptionHintsOpen = false;
    },
  },

  methods: {
    getCardData() {
      const localData = cardActivation.getMoCardData();

      if (localData) {
        this.cardNumber = `000${localData.card_number}`;
        this.cardNumberArray = this.cardNumber.match(/.{1,4}/g);

        if (localData.pin_code) {
          this.pinCode = localData.pin_code;
        }
      } else {
        this.isCardActivation = false;
      }
    },

    toggleDescriptionHintsState(state) {
      this.isDescriptionHintsOpen = state === undefined ? !this.isDescriptionHintsOpen : state;
    },

    checkPasswordRating(rating) {
      this.passwordRating = rating;
      this.isDescriptionHintsOpen = rating !== STRONG_PASSWORD;
    },

    onCancel() {
      this.$router.push('/sign_in');
    },

    async onSubmit() {
      if (!this.validate()) {
        return;
      }

      const data = {
        birthday: this.birthday,
        email: this.email,
        first_name: this.name,
        is_male: this.gender < 0,
        last_name: this.secondName,
        password: this.password,
        validation_code: this.code,
        validation_code_type: 'email',
        country_id: this.location.country.id,
        lang: this.$i18n.locale
      };

      if (this.isCardActivation) {
        data.card_number = this.cardNumber.replace(/^0+/, '');
        data.pin_code = this.pinCode;
      }

      if (this.patronymic) {
        data.middle_name = this.patronymic;
      }

      this.isCanSubmit = false;
      try {
        await Api.post({ url: 'create-user', data });
      } catch (error) {
        this.isError = true;
        this.errorCode = error.code;
        this.isCanSubmit = true;
        window.console.log(this.errorCode);

        return;
      }

      registrationHelper.clearData();
      cardActivation.clearMoCardData();

      this.isCanSubmit = true;
      this.$router.push('success');
    },

    validate() {
      this.validated = true;

      if (!this.$refs.secondName.validate()) {
        this.validated = false;
      }

      if (!this.$refs.name.validate()) {
        this.validated = false;
      }

      if (!this.$refs.birthday.validate()) {
        this.validated = false;
      }

      if (!this.$refs.password.validate() || this.passwordRating === WEAK_PASSWORD) {
        this.validated = false;
      }

      if (!this.$refs.checkbox.validate()) {
        this.validated = false;
      }

      if (!this.$refs.location.validate()) {
        this.validated = false;
      }

      return this.validated;
    },

    fieldsChanged() {
      this.validated = true;
      this.isError = false;
    },
  },

  created() {
    const localData = registrationHelper.getDataToRestore();

    if (!localData) {
      this.$router.push('/registration');
      return;
    }

    const expires = registrationHelper.getExpirationSeconds((new Date(localData.expires)));

    if (expires <= 0) {
      registrationHelper.clearData();
      this.$router.push('/registration');
      return;
    }

    this.email = localData.email;
    this.code = localData.code;
  },

  data() {
    return {
      errorCode: null,
      validated: this.validated || true,
      isError: false,
      birthday: null,
      name: null,
      secondName: null,
      patronymic: null,
      gender: '-1',
      email: null,
      location: {},
      password: null,
      isDescriptionHintsOpen: false,
      isChecked: false,
      isCanSubmit: true,
    };
  },
};
